// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_fp-9";
export var fulfillmentFormRail = "_fp-8";
export var headerTitleRow = "_fp-b";
export var orderDetailsWrapper = "_fp-6";
export var paymentInformationGrid = "_fp-g";
export var paymentSummaryColumn = "_fp-h";
export var shipmentContainer = "_fp-a";
export var shipmentDetailsMainPane = "_fp-7";
export var shipmentNavigationCard = "_fp-4";
export var shipmentNavigationRail = "_fp-2";
export var shipmentNavigationRailHeader = "_fp-3";
export var shipmentSummaryFact = "_fp-d";
export var shipmentSummaryGrid = "_fp-c";
export var shipmentSummaryMetadataRow = "_fp-e";
export var shipmentSummaryTags = "_fp-f";
export var shipmentWorkspace = "_fp-0";
export var shipmentWorkspaceContent = "_fp-5";
export var shipmentWorkspaceHeader = "_fp-1";